export const STORAGE_KEYS = {
  THEME: 'theme',
  AUTH_STATUS: '_tapaz_authStatus',
  BOOKMARKS: '_tapaz_bookmarks',
  VIEWED_ADS: '_tapaz_viewed_ads',
  LAST_ADS_DATA: '_tapaz_last_ads_data',
  LAST_SCROLL_POSITION_DATA: '_tapaz_last_scroll_position_data',
  CATALOGUE_SCROLL_LEFT: '_tapaz_catalogue_scroll_left',
  NEED_TO_RESTORE_SCROLL_POSITION: '_tapaz_need_to_restore_scroll_position',
  AUTH_STORAGE: '_tapaz_auth_storage',
  BRIDGE: '_tapaz_bridge_storage',
  SHOP_CREATE_BLOCKED: '_tapaz_shop_create_blocked',
};

export const SESSION_KEYS_CLEARED_ON_LOGOUT = [
  STORAGE_KEYS.SHOP_CREATE_BLOCKED,
];
